// Navigation des Moduls `chat` (eager geladen; Quelle UX §2.2–§2.10). Besitzer: Modul chat.
import { ChatsCircle } from '@phosphor-icons/react';
import { defineMeta } from '@web/registry/define';

export default defineMeta({
  key: 'chat',
  title: 'Company chat',
  nav: {
    people: [
      {
        key: 'chat.rail',
        label: 'Chat',
        icon: ChatsCircle,
        path: '/chat',
        roles: ['ALL'],
        order: 70,
        area: 'rail',
      },
    ],
  },
});
